// +----------------------------------------------------------------------
// | Desc:全局路由定义
// +----------------------------------------------------------------------
const allRouters = [
  // +----------------------------------------------------------------------
  // | Desc:专利列表
  // +----------------------------------------------------------------------
  {
    path: "/index",
    name: "index",
    title: "首页",
    component: () => import("@/pages/index/index"),
    meta: {
      requireAuth: false,
    },
  },

  // +----------------------------------------------------------------------
  // | Desc:购物车
  // +----------------------------------------------------------------------
  {
    path: "/car",
    name: "car",
    title: "购物车",
    component: () => import("@/pages/index/car"),
    meta: {
      requireAuth: false,
    },
  },

  // +----------------------------------------------------------------------
  // | Desc:系统基础模块
  // +----------------------------------------------------------------------
  {
    path: "/",
    name: "/",
    title: "默认访问",
    redirect: "/index",
    meta: {
      requireAuth: false,
    },
  },
  {
    path: "*",
    name: "404页",
    title: "404",
    component: () => import("@/layout/pages/404/404"),
  },
  {
    path: "/error",
    name: "error",
    title: "访问受限页",
    component: () => import("@/layout/pages/error/error"),
    meta: {
      requireAuth: false,
    },
  },
];
export const routers = [...allRouters];
